

<section class="bg-half-170 bg-light d-table w-100" id="home" style="background: url('assets/images/blog/breadcrumb.png');">
    <div class="container">
        <div class="row mt-5 justify-content-center">
            <!-- <div class="col-lg-12 text-center">
                <div class="pages-heading">
                      <h2> {{currentLang === 'ar' ? blog.TiteleAr : blog.TiteleEn }}  </h2>
          <ul class="list-unstyled mt-4 mb-0">
            <li class="list-inline-item h6 date text-muted"><i class="mdi mdi-calendar-check"></i> {{blog.createDate | date : 'dd/MM/yyyy'}} </li>
          </ul>
                </div>
            </div>  -->
        </div><!--end row-->
  <div class="position-breadcrumb">
      <nav aria-label="breadcrumb" class="d-inline-block">
        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
          <li class="breadcrumb-item"><a routerLink="/">{{'Home' | translate}}</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{'Aboutus' | translate}}</li>
        </ul>
      </nav>
    </div>
    
    </div> <!--end container-->
</section><!--end section-->

<div class="position-relative">
  <div class="shape overflow-hidden text-color-white">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!-- Hero End -->

<section class="section" *ngIf="about && about.length > 0">
  <div class="container">
    <div class="row align-items-center" id="counter" *ngFor="let item of about">
      <div class="col-md-6" >
        <img src="{{item.ImageUrl}}" class="img-fluid" alt="">
      </div>
      <!--end col-->

      <div class="col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
        <div class="ms-lg-4">
          <div class="d-flex mb-4">
            <span class="text-primary h1 mb-0"><span class="counter-value display-1 fw-bold" [countUp]="15" [options]="option"></span>+</span>
            <span class="h6 align-self-end ms-2">{{'Years' | translate}} <br> {{'Experience' | translate}}</span>
          </div>
          <div class="section-title">
            <h4 class="title mb-4"> {{currentLang == 'ar' ? item.TitleAr : item.TitleEn}} </h4>
            <p class="text-muted">{{currentLang == 'ar' ? item.DescriptionAr : item.DescriptionEn}}</p>
            <a routerLink="/contact" class="btn btn-primary mt-3">{{'Contact us' | translate}}</a>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <!--end container-->
</section>
<!--end section-->

<section class="section bg-light">
  <div class="container">
<div class="container mt-100 mt-60">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="section-title text-center mb-4 pb-2">
        <h6 class="text-primary">{{'Work Process' | translate}}</h6>
        <h4 class="title mb-4">{{'How do we work?' | translate}}</h4>
        <p class="text-muted para-desc mx-auto mb-0">
          {{'From pickup to delivery, ' | translate}}<span class="text-primary fw-bold">{{'Easy Wash' | translate}}</span>
          {{' takes care of every step so you get clean, fresh laundry without any hassle.' | translate}}
        </p>
      </div>
    </div><!--end col-->
  </div><!--end row-->

  <div class="row">
    <!-- Step 1: Pickup -->
    <div class="col-md-4 mt-4 pt-2">
        <div class="card features feature-primary feature-clean work-process bg-transparent  border-0 text-center"
      >
        <div class="icons text-center mx-auto">
          <i class="uil uil-box d-block rounded h3 mb-0"></i>
        </div>
        <div class="card-body">
          <h5 class="text-dark">{{'Pickup' | translate}}</h5>
          <p class="text-muted mb-0">
            {{'Schedule a pickup time that suits you, and our team collects your laundry directly from your doorstep.' | translate}}
          </p>
        </div>
      </div>
    </div><!--end col-->

    <!-- Step 2: Wash -->
    <div class="col-md-4 mt-md-5 pt-md-3 mt-4 pt-2">
  <div class="card features feature-primary feature-clean work-process bg-transparent  border-0 text-center">
        <div class="icons text-center mx-auto">
          <i class="uil uil-water-glass d-block rounded h3 mb-0"></i>
        </div>
        <div class="card-body">
          <h5 class="text-dark">{{'Wash' | translate}}</h5>
          <p class="text-muted mb-0">
            {{'Your clothes are professionally cleaned using high-quality equipment and safe, effective detergents.' | translate}}
          </p>
        </div>
      </div>
    </div><!--end col-->

    <!-- Step 3: Delivery -->
    <div class="col-md-4 mt-md-5 pt-md-5 mt-4 pt-2">
        <div class="card features feature-primary feature-clean work-process bg-transparent  border-0 text-center"
      >
        <div class="icons text-center mx-auto">
          <i class="uil uil-truck d-block rounded h3 mb-0"></i>
        </div>
        <div class="card-body">
          <h5 class="text-dark">{{'Delivery' | translate}}</h5>
          <p class="text-muted mb-0">
            {{'Fresh, clean, and neatly folded — your laundry is delivered back to you right on schedule.' | translate}}
          </p>
        </div>
      </div>
    </div><!--end col-->
  </div><!--end row-->
</div>
  </div>
  <!--end container-->


  <!--end container-->
</section>
<!--end section-->
      <div class="container mt-100 mt-60" *ngIf="temamembers && temamembers.length>0">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="section-title text-center mb-4 pb-2">
                    <h4 class="title mb-4">{{'Team Members' | translate}}</h4>
                    <p class="text-muted mx-auto para-desc mb-0">{{'Our professional team members' | translate}}</p>
                </div>
            </div><!--end col-->
        </div><!--end row-->

        <div class="row" *ngIf="temamembers && temamembers.length > 0">
           <team-carousel [temamembers]="temamembers" [currentLang]="currentLang"></team-carousel>
            <!-- <div class="col-lg-3 col-md-6 mt-4 pt-2" *ngFor="let item of temamembers">
                <div class="card team team-primary text-center border-0">
                    <div class="position-relative">
                        <img src="{{item.ImageUrl}}"
                            class="img-fluid avatar avatar-ex-large rounded-circle shadow" alt="">
                        <ul class="list-unstyled mb-0 team-icon">
                            <li class="list-inline-item ms-1"><a href="{{item.Facebook}}"
                                    class="btn btn-primary btn-pills btn-sm btn-icon"><i-feather name="facebook"
                                        class="icons"></i-feather></a></li>
                            <li class="list-inline-item ms-1"><a href="{{item.Instagram}}"
                                    class="btn btn-primary btn-pills btn-sm btn-icon"><i-feather name="instagram"
                                        class="icons"></i-feather></a></li>
                            <li class="list-inline-item ms-1"><a href="{{item.Twitter}}"
                                    class="btn btn-primary btn-pills btn-sm btn-icon"><i-feather name="twitter"
                                        class="icons"></i-feather></a></li>
                            <li class="list-inline-item ms-1"><a href="{{item.LinkedIn}}"
                                    class="btn btn-primary btn-pills btn-sm btn-icon"><i-feather name="linkedin"
                                        class="icons"></i-feather></a></li>
                        </ul>
                    </div>
                    <div class="card-body py-3 px-0 content">
                        <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">{{ currentLang != 'ar' ? item.NameEn : item.NameAr }}  </a></h5>
                        <small class="designation text-muted">{{ currentLang != 'ar' ? item.JobTitleEn : item.JobTitleAr }}</small>
                    </div>
                </div>
            </div> -->

          
        </div><!--end row-->
    </div><!--end container-->
<!-- ============================================================ -->
<!--   قسم الإحصائيات (إنجازاتنا) – مع أنيميشن عند التمرير          -->
<!-- ============================================================ -->
<section class="section stats-section py-5" style="background: #f8faff; position: relative; overflow: hidden;">
  <!-- خلفية مزينة بأشكال دائرية (اختياري) -->
  <div class="shape-circle" style="position: absolute; top: -80px; right: -80px; width: 300px; height: 300px; background: rgba(52, 152, 219, 0.04); border-radius: 50%;"></div>
  <div class="shape-circle" style="position: absolute; bottom: -100px; left: -100px; width: 400px; height: 400px; background: rgba(52, 152, 219, 0.03); border-radius: 50%;"></div>

  <div class="container position-relative" style="z-index: 2;">
    <!-- عنوان القسم -->
    <div class="row justify-content-center">
      <div class="col-lg-8 text-center">
        <h6 class="text-primary fw-bold text-uppercase mb-2" style="letter-spacing: 2px;">
          {{ 'Achievements' | translate }}
        </h6>
        <h2 class="display-5 fw-semibold mb-4">
          {{ 'نثبت كفاءتنا التشغيلية بالإنجازات' | translate }}
        </h2>
        <p class="text-muted lead mb-5">
          {{ 'نضع بين أيديكم خبراتنا اللوجستية لنضمن نمو أعمالكم من خلال حلول غسل ذكية وموثوقة' | translate }}
        </p>
      </div>
    </div>

    <!-- بطاقات الإحصائيات الأربع -->
    <div class="row g-4 justify-content-center">
      <!-- البطاقة 1: طن يومياً -->
      <div class="col-lg-3 col-md-6 col-12" data-aos="fade-up" data-aos-delay="100">
        <div class="stat-card text-center p-4 rounded-4 shadow-sm h-100 border-0 bg-white transition-all" style="border-bottom: 5px solid #4fc3f7;">
          <div class="stat-icon mb-3">
            <i class="mdi mdi-weight-kilogram display-4 text-primary"></i>
          </div>
          <div class="stat-number display-3 fw-bold text-dark">
            <span class="counter-value" [countUp]="21" [options]="option"></span><span class="h2">+</span>
          </div>
          <p class="stat-label text-muted mb-0 h6 fw-normal" style="letter-spacing: 1px;">
            {{ 'طن يومياً' | translate }}
          </p>
          <small class="text-primary fw-light">{{ 'سعة غسيل يومية' | translate }}</small>
        </div>
      </div>

      <!-- البطاقة 2: شريك استراتيجي -->
      <div class="col-lg-3 col-md-6 col-12" data-aos="fade-up" data-aos-delay="200">
        <div class="stat-card text-center p-4 rounded-4 shadow-sm h-100 border-0 bg-white transition-all" style="border-bottom: 5px solid #f39c12;">
          <div class="stat-icon mb-3">
            <i class="mdi mdi-handshake display-4 text-warning"></i>
          </div>
          <div class="stat-number display-3 fw-bold text-dark">
            <span class="counter-value" [countUp]="43" [options]="option"></span><span class="h2">+</span>
          </div>
          <p class="stat-label text-muted mb-0 h6 fw-normal" style="letter-spacing: 1px;">
            {{ 'شريك استراتيجي' | translate }}
          </p>
          <small class="text-warning fw-light">{{ 'شراكات موثوقة' | translate }}</small>
        </div>
      </div>

      <!-- البطاقة 3: مركبات لوجستية -->
      <div class="col-lg-3 col-md-6 col-12" data-aos="fade-up" data-aos-delay="300">
        <div class="stat-card text-center p-4 rounded-4 shadow-sm h-100 border-0 bg-white transition-all" style="border-bottom: 5px solid #2ecc71;">
          <div class="stat-icon mb-3">
            <i class="mdi mdi-truck-fast display-4 text-success"></i>
          </div>
          <div class="stat-number display-3 fw-bold text-dark">
            <span class="counter-value" [countUp]="27" [options]="option"></span><span class="h2">+</span>
          </div>
          <p class="stat-label text-muted mb-0 h6 fw-normal" style="letter-spacing: 1px;">
            {{ 'مركبات لوجستية' | translate }}
          </p>
          <small class="text-success fw-light">{{ 'أسطول توصيل حديث' | translate }}</small>
        </div>
      </div>

      <!-- البطاقة 4: تشغيل ذكي ومستمر -->
      <div class="col-lg-3 col-md-6 col-12" data-aos="fade-up" data-aos-delay="400">
        <div class="stat-card text-center p-4 rounded-4 shadow-sm h-100 border-0 bg-white transition-all" style="border-bottom: 5px solid #e74c3c;">
          <div class="stat-icon mb-3">
            <i class="mdi mdi-brain display-4 text-danger"></i>
          </div>
          <div class="stat-number display-3 fw-bold text-dark">
            <span class="counter-value" [countUp]="1" [options]="option"></span><span class="h2">+</span>
          </div>
          <p class="stat-label text-muted mb-0 h6 fw-normal" style="letter-spacing: 1px;">
            {{ 'تشغيل ذكي ومستمر' | translate }}
          </p>
          <small class="text-danger fw-light">{{ 'كفاءة 24/7' | translate }}</small>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->